module.exports = __webpack_public_path__ + "img/p2.35ba32ab.png";